<template>
  <div class="bg">
    <div class="box">
      <div class="window">
        <div class="window-left">
          <div class="window-left-title">养老机构服务信用评价平台</div>
          <img class="window-left-img" src="../assets/login.png"/>
        </div>
        <div class="window-right">
          <div class="window-right-title login-title">个 人 注 册</div>
          <el-input class="login-input"
                    @keyup.enter.native="doRegister" v-model="phone" :placeholder="phoneRule"/>
          <el-input class="login-input"
                    @keyup.enter.native="doRegister" v-model="password" :placeholder="passwordRule" show-password/>
          <el-input
            @keyup.enter.native="doRegister" class="login-input" v-model="password2" :placeholder="password2Rule" show-password/>
          <div class="yzm">
            <el-input
              @keyup.enter.native="doRegister" class="yzm-input1" v-model="code" :placeholder="codeRule"></el-input>
            <el-button class="yzm-btn" type="primary" @click="getCode" :disabled="disabled">{{ validBtn }}</el-button>
          </div>
          <el-button class="login-btn" type="primary" @click="doRegister" :loading="loading">
            <span v-if="!loading">立即注册</span>
            <span v-else>注册中...</span>
          </el-button>
          <div class="test-main-bottom">
            <el-checkbox v-model="checked" class="xieyi-checkbox"/>
            <div class="xieyi">我已阅读并同意<a class="xieyi-a" @click="openAgreement">《用户协议》</a><a class="xieyi-a"
                                                                                                        @click="openYinSi">《隐私权政策》</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {registerPerson, repeat, sendMsg} from "@/api/login";

export default {
  name: 'RegisterPerson',
  data() {
    return {
      phone: "",
      code: "",
      loading: false,
      phoneRule: "请输入手机号",
      codeRule: "请输入4位验证码",
      passwordRule: "请输入密码",
      password2Rule: "请再次输入密码",
      password: "",
      password2: "",
      disabled: false,
      options: [
        {
          value: 1,
          label: "养老机构"
        }
      ],
      validBtn: '获取验证码',
      checked: false,

    }
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    // 获取验证码
    getCode() {
      if (!this.phone) {
        this.$message.error(this.phoneRule)
        return false
      }
      if (!this.rulerCheck('phone', this.phone)) {
        this.$message.error("联系电话不正确")
        return false
      }
      this.tackBtn();   //验证码倒数60秒
      // 发送短信验证码
      sendMsg({
        phone: this.phone,
        type: 0
      }).then(() => {
        this.$message.success("发送成功！")
      }).catch(() => {
        this.validBtn = '获取验证码';
      });
    },
    tackBtn() {       //验证码倒数60秒
      let time = 60;
      let timer = setInterval(() => {
        if (time === 0) {
          clearInterval(timer);
          this.validBtn = '获取验证码';
          this.disabled = false;
        } else {
          this.disabled = true;
          this.validBtn = time + '秒后重试';
          time--;
        }
      }, 1000);
    },
    // 注册按钮
    doRegister() {
      // 非空校验
      if (!this.checkParams()) return
      if (!this.checked) {
        this.$message.error("请勾选阅读并同意协议")
        return
      }
      // 重复校验
      repeat({key: "username", val: this.username}).then(res2 => {
        this.doRegisterReal()
      })

    },
    doRegisterReal() {
      this.loading = true;
      // 注册
      registerPerson({
        code: this.code,
        phone: this.phone,
        password: this.password,
      }).then(() => {
        this.$message.success("账号" + this.phone + "注册成功！")
        this.$router.push("/login");
      }).catch(() => {
        this.loading = false;
      });
    },
    // 打开协议窗口
    openAgreement() {
      const w = window.open("about:blank")
      w.location.href = 'https://admin.zhihuiyanglao.com.cn/api/profile/upload/diandianxieyi.pdf';
    },
    // 打开隐私窗口
    openYinSi() {
      const w = window.open("about:blank")
      w.location.href = 'https://admin.zhihuiyanglao.com.cn/api/profile/upload/diandianxieyi.pdf';
    },
    // 通过校验返回 true,否则返回 false
    checkParams() {
      if (!this.phone) {
        this.$message.error(this.phoneRule)
        return false
      }
      if (!this.rulerCheck('phone', this.phone)) {
        this.$message.error("手机号码不正确")
        return false
      }
      if (!this.password) {
        this.$message.error(this.passwordRule)
        return false
      }
      if (!this.password2) {
        this.$message.error(this.password2Rule)
        return false
      }
      if (this.password !== this.password2) {
        this.$message.error("两次输入的密码不一致")
        return false
      }
      if (!this.code) {
        this.$message.error(this.codeRule)
        return false
      }
      return true
    }
  }
}
</script>
<style>
.login-title {
  margin: 20px auto 60px;
}

.test-main-bottom {
  width: 350px;
  height: 80px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

/*底部操作栏*/
.xieyi {
  margin-left: 10px;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 14px;
  color: rgba(51, 51, 51, 1);
}

/*深度选择器*/
.xieyi-checkbox /deep/ .el-checkbox__inner {
  margin: 0px 0px 0 0;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(196, 196, 196, 1) !important;
}

.xieyi-a {
  color: rgba(63, 140, 255, 1);
}

.getAuthCode {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  color: #526ECC;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 14px;
}
</style>
<style scoped>
.register-title {
  margin: 27px auto 10px;
}

.el-form-item {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/RegisterPerson.vue